import {InjectionToken} from '@angular/core'

/**
 * Defines and exports an injection token that replaces the browser
 * window object.
 */
export const WINDOW = new InjectionToken<Window>('window')

export const OLD_DOWN_PAYMENT = 0.15
export const NEW_DOWN_PAYMENT = 0.10
const SWITCH_DATE = new Date('2026-04-01T00:00:00')

export const getCurrentDownPaymentPercent = (isTestMode: boolean): number => {
  const isPastDate = new Date() >= SWITCH_DATE

  // isTestMode is only needed for testing before April 1st, 2026.
  // After this date, the flag and this check can be removed.
  return (isPastDate || isTestMode)
    ? NEW_DOWN_PAYMENT
    : OLD_DOWN_PAYMENT
}